module.exports = __webpack_public_path__ + "static/virksomheder-e33973b1cffe20b68dfae89709fe8dae.png";